declare var require;

export class AnimationContents {
  public static FULLSCREEN_JSON = require('../animate/FullScreen.json');
  public static ORIENTATION_SCREEN_JSON = require('../animate/OrientationScreen.json');
  public static BACKGROUNDS_JSON = require('../animate/Backgrounds.json');

  public static GAME_SCREEN_JSON = require('../animate/GameScreen.json');
  public static GAME_SCREEN_MOBILE_JSON = require('../animate/GameScreenMobile.json');
  public static DIALOG_BOOK_SCREEN_JSON = require('../animate/DialogBookScreen.json');
  public static MAIN_SCREEN_JSON = require('../animate/MainScreen.json');
  public static WIN_SCREEN_JSON = require('../animate/WinScreen.json');
  public static SHOP_SCREEN_JSON = require('../animate/ShopScreen.json');
  public static SHOP_LIFE_SCREEN_JSON = require('../animate/ShopLifeScreen.json');
  public static SHOP_NEEDLE_SCREEN_JSON = require('../animate/ShopNeedleScreen.json');
  public static FRIENDS_LIST_MODAL_JSON = require('../animate/FriendsListModal.json');
  public static TOP_BAR_MENU_JSON = require('../animate/TopBarMenu.json');
  public static SHOP_CRAZY_GAMES_JSON = require('../animate/ShopCrazyGames.json');
  public static CONFIRMATIONS_JSON = require('../animate/Confirmations.json');
  public static CATALOG_JSON = require('../animate/Catalog.json');
  public static LOADER_SCREEN_JSON = require('../animate/LoadingScreen.json');
  public static FTUE_WELCOME_SCREEN_JSON = require('../animate/FTUEWelcomeScreen.json');
  public static DAILY_REWARD_SCREEN = require('../animate/DailyRewardModal.json');
  public static CATALOG_TAGS_LIST = {};
}

fetch("https://raw.githubusercontent.com/Nord-Beaver/bw-content/stable/catalog.tags.json")
.then(res => res.json())
.then(content => {
  AnimationContents.CATALOG_TAGS_LIST = content;
})
